// extracted by css-extract-rspack-plugin
export default {"additionalContainer":"additional-container--XFgII6td68GoHFTh","additionalItem":"additional-item--Yhxlkn3YIjU5W30a"};